export default __webpack_public_path__ + "static/spruce-b89e79aaffd447872e2a1d4783227c08.png";